import { KEYS } from "../../../Config/Keys";
import React from "react";

import { List, Checkbox, Button } from "antd";
import NumberDropdown from "./NumberDropdown";
import { FiUsers } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import { IoTimerSharp } from "react-icons/io5";
import { SiNike } from "react-icons/si";
import dayjs from "dayjs";
import classes from "./index.module.css";
import { totalAwardValue } from "../../../common/Utils";

const Teams = ({ loading, Teams, selectedOptions, handleCheckboxChange, resetFilter }) => {
  const navigate = useNavigate();
  const handleDropdownChange = (name, value) => {
    handleCheckboxChange(name, value);
  };

  return (
    <div className="">
      <div className={classes.checkboxContainer}>
        <NumberDropdown
          onChange={(value) => handleDropdownChange("eventsParticipated", value)}
          label="No of Event Participate"
          selectedValue={selectedOptions.eventsParticipated}
        />
        <NumberDropdown
          onChange={(value) => handleDropdownChange("awardWin", value)}
          label="No of Award Win"
          selectedValue={selectedOptions.awardWin}
        />
        <Checkbox
          className={classes.checkboxitem}
          name="sponsors"
          checked={selectedOptions.sponsors}
          onChange={(e) => handleCheckboxChange(e.target.name, e.target.checked)}>
          Sponsers
        </Checkbox>
        <Button
          type="primary"
          size="small"
          shape="round"
          className={classes.clearFilterBtn}
          onClick={() => resetFilter("team")}>
          Clear Filter
        </Button>
      </div>
      <List
        itemLayout="horizontal"
        className="searchedlistItemParent"
        loading={loading}
        dataSource={Teams || []}
        renderItem={(item, index) => {
          return (
            <List.Item
              key={index}
              onClick={() => {
                navigate(`/view/team/${item?._id}/timeline`);
              }}
              className={classes.listContainer}>
              {item.typeofsports && (
                <div className={classes.topTitle} style={{ flexBasis: "100%" }}>
                  {item.typeofsports + "-"} <span>{item?.nameofsports?.toUpperCase()}</span>
                </div>
              )}
              <div className={classes.fileContainer}>
                <img
                  src={KEYS?.API + "/" + item?.profilepic}
                  alt=""
                  style={{ borderRadius: "50%" }}
                />
              </div>
              <div style={{ flex: 1, marginTop: "1rem" }}>
                <h3 className={classes.title}> {item?.name}</h3>
                <h3 className={classes.panel}>{item?.username || "username"}</h3>
                <h3 className={classes.panel}>Events:</h3>
                <p className={classes.eventDate}>
                  {" "}
                  {item?.startDate ? dayjs(item?.startDate)?.format("DD MMMM ") : ""}
                </p>
                <div className={classes.task}>
                  <FaCheckCircle style={{ color: "#15b215" }} />
                  <span style={{ color: "#0085ff" }}>{item?.eventsParticipated || 0}</span>
                  <IoTimerSharp style={{ color: "red", marginLeft: "10px" }} />
                  <span style={{ color: "red" }}>{item?.ongoingEvents || 0}</span>
                </div>

                <div className={classes.searchListItemInfo}>
                  <span>
                    <FiUsers />
                  </span>
                  {item?.followerCount || item?.followers?.length || 0 + " Followers"}
                </div>
              </div>
              <div className={classes.rewardContainer}>
                <div className={classes.bottomleft}>
                  <div className={classes.moneyIcon}>
                    <img alt="money" src="/images/icons/money-2.png" />
                    <span>Rs {item?.totalCash || totalAwardValue(item?.eventAwards) || 0} </span>
                  </div>
                  <div>
                    <img alt="certificates" src="/images/icons/cert-2.png" />
                    <span>{item?.totalCertificates || 0} certificates</span>
                  </div>
                  <div>
                    <img alt="shield" src="/images/icons/shield-2.png" />
                    <span>{item?.totalShields || 0} Shields</span>
                  </div>
                </div>
                <div className={classes.sponsors}>
                  <p>Sponsors:</p>
                  <div>
                    <SiNike />
                  </div>
                  <div
                    style={{
                      borderLeft: "0.5px solid #c3c3c3",
                      paddingLeft: "15px"
                    }}>
                    <SiNike />
                  </div>
                </div>
              </div>
            </List.Item>
          );
        }}
      />
    </div>
  );
};

export default Teams;
